import { render, staticRenderFns } from "./tongueAppearance.vue?vue&type=template&id=34200f5f&scoped=true&"
import script from "./tongueAppearance.vue?vue&type=script&lang=ts&"
export * from "./tongueAppearance.vue?vue&type=script&lang=ts&"
import style0 from "./tongueAppearance.vue?vue&type=style&index=0&id=34200f5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34200f5f",
  null
  
)

export default component.exports